import {
	Component, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList,
	AfterViewInit
} from '@angular/core';
import { IdentityService } from '../../services/identity.service';
import { NavigationService } from 'netview';
import { UserListComponent, UserPermissionsService, GroupListComponent } from 'identity';
import { AccountType } from '../../../UvExplorerServer.Dtos.TS';
import { AuthSettingsComponent } from '../auth-settings/auth-settings.component';
import { UserPermissions } from '../../../UvExplorerServer.Dtos.TS/Auth';
import { AdminReportsComponent } from 'infosets';


@Component({
    selector: 'admin',
	templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, OnDestroy {

	@ViewChildren(UserListComponent)
	public userLists: QueryList<UserListComponent>;

	@ViewChildren(GroupListComponent)
	public groupLists: QueryList<GroupListComponent>;

	@ViewChildren(AuthSettingsComponent)
	public authSettings: QueryList<AuthSettingsComponent>;

	@ViewChildren(AdminReportsComponent)
	public adminReports: QueryList<AdminReportsComponent>;

	public activeIndex: number;

	private readonly AdminReportsTabIndex = 6;

	constructor(private identityService: IdentityService,
		private userPermissionsService: UserPermissionsService,
		private navService: NavigationService) {

		this.activeIndex = 0;
	}

	public ngOnInit(): void {
	}

	public ngAfterViewInit() {
		if (this.navService.location.hasContext) {
			const UserListCreateUserGoogleWorkspacePath = '/userlist/createuser/googleworkspace';
			const UserListEditUserGoogleWorkspacePath = '/userlist/edituser/googleworkspace/';
			const UserListLoginAdminFailedPath = '/userlist/loginadmin/failed';
			const GroupListCreateGroupGoogleWorkspacePath = '/grouplist/creategroup/googleworkspace';
			const GroupListEditGroupGoogleWorkspacePath = '/grouplist/editgroup/googleworkspace/';
			const GroupListSyncGroupsGoogleWorkspacePath = '/grouplist/syncgroups/googleworkspace';
			const GroupListLoginAdminFailedPath = '/grouplist/loginadmin/failed';
			const AuthSettingsSaveGoogleWorkspacePath = '/authsettings/save/googleworkspace';
			const AuthSettingsLoginAdminFailedPath = '/authsettings/loginadmin/failed';

			const UserListTabIndex = 0;
			const GroupListTabIndex = 1;
			const AuthSettingsTabIndex = 2;

			let context = this.navService.location.context;
			if (context === UserListCreateUserGoogleWorkspacePath) {
				setTimeout(() => {
					this.setSelectedTab(UserListTabIndex);
					let userlist = this.userLists.first;
					setTimeout(() => {
						userlist.createDirectoryUser(AccountType.GoogleWorkspace);
					}, 0);
				}, 0);
			}
			else if (context.startsWith(UserListEditUserGoogleWorkspacePath)) {
				let userGuid = context.substr(UserListEditUserGoogleWorkspacePath.length);
				if (userGuid) {
					setTimeout(() => {
						this.setSelectedTab(UserListTabIndex);
						let userlist = this.userLists.first;
						setTimeout(() => {
							userlist.editDirectoryUserByGuid(userGuid);
						}, 0);
					}, 0);
				}
			}
			else if (context === UserListLoginAdminFailedPath) {
				setTimeout(() => {
					this.setSelectedTab(UserListTabIndex);
					let userlist = this.userLists.first;
					setTimeout(() => {
						userlist.onAdminLoginFailed();
					}, 0);
				}, 0);
			}
			else if (context === GroupListCreateGroupGoogleWorkspacePath) {
				setTimeout(() => {
					this.setSelectedTab(GroupListTabIndex);
					let grouplist = this.groupLists.first;
					setTimeout(() => {
						grouplist.createDirectoryGroup(AccountType.GoogleWorkspace);
					}, 0);
				}, 0);
			}
			else if (context.startsWith(GroupListEditGroupGoogleWorkspacePath)) {
				let groupGuid = context.substr(GroupListEditGroupGoogleWorkspacePath.length);
				if (groupGuid) {
					setTimeout(() => {
						this.setSelectedTab(GroupListTabIndex);
						let grouplist = this.groupLists.first;
						setTimeout(() => {
							grouplist.editDirectoryGroupByGuid(groupGuid);
						}, 0);
					}, 0);
				}
			}
			else if (context === GroupListSyncGroupsGoogleWorkspacePath) {
				setTimeout(() => {
					this.setSelectedTab(GroupListTabIndex);
					let grouplist = this.groupLists.first;
					setTimeout(() => {
						grouplist.syncDirectoryGroups(AccountType.GoogleWorkspace);
					}, 0);
				}, 0);
			}
			else if (context === GroupListLoginAdminFailedPath) {
				setTimeout(() => {
					this.setSelectedTab(GroupListTabIndex);
					let grouplist = this.groupLists.first;
					setTimeout(() => {
						grouplist.onAdminLoginFailed();
					}, 0);
				}, 0);
			}
			else if (context === AuthSettingsSaveGoogleWorkspacePath) {
				setTimeout(() => {
					this.setSelectedTab(AuthSettingsTabIndex);
					let authSettings = this.authSettings.first;
					setTimeout(() => {
						authSettings.onOauthSave();
					}, 0);
				}, 0);
			}
			else if (context === AuthSettingsLoginAdminFailedPath) {
				setTimeout(() => {
					this.setSelectedTab(AuthSettingsTabIndex);
					let authSettings = this.authSettings.first;
					setTimeout(() => {
						authSettings.onAdminLoginFailed();
					}, 0);
				}, 0);
			}
		}
	}

	private setSelectedTab(tabIndex: number): void {
		this.activeIndex = tabIndex;
	}

	public ngOnDestroy(): void {

	}

	public get isLoggedIn(): boolean {
		return this.identityService.isLoggedIn;
	}

	public get isAdmin(): boolean {
		return this.identityService.isAdmin;
	}

	public get isObserver(): boolean {
		return this.identityService.isObserver;
	}

	public onTabChange(event: any): void {
		switch (event.index) {	
			case this.AdminReportsTabIndex:
				if (!!this.adminReports && this.adminReports.first) {
					this.adminReports.first.reloadReport();
				}
				break;
		}
	}

}
